import BarChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "KRentalPickupsTimeChart",

	mixins: [ BarChartMixin ],

	props: {
		report: {
			required: true,
			type: Object
		}
	},

	data: () => ( {
		title: "Time to Complete",
		yAxisLabel: "Rental Pickups (Count)"
	} ),

	computed: {
		barData() {
			return [
				this.report.lessThan24Hours,
				this.report.greaterThan24Hours,
				this.report.total
			];
		},

		labels() {
			return [
				"Less Than 24 Hours",
				"More Than 24 Hours",
				"Total"
			];
		}
	}
};
